import { distance } from "@turf/distance";
import type { Coordinate } from "ol/coordinate";
import type Feature from "ol/Feature";
import type PointGeom from "ol/geom/Point";
import { toLonLat } from "ol/proj";

import { minBy } from "../arrayutil/minby";

/**
 * 指定されたフィーチャーのうち、最も基準点に近い位置にあるものを返す。
 *
 * @param basePoint3857 基準点(EPSG:3857)
 * @param features3857 対象のフィーチャーの配列(EPSG:3857)
 * @returns フィーチャー
 */
export const findNearestFeature = (basePoint3857: Coordinate, features3857: Feature<PointGeom>[]) => {
    if (!features3857.length) {
        throw new Error("no features.");
    }

    // 基準点をWGS84に変換
    const basePointLonLat = toLonLat(basePoint3857);

    return minBy(features3857, (feature) => {
        const geometry = feature.getGeometry();
        if (!geometry) {
            return Infinity;
        }

        // フィーチャーの座標を取得してWGS84に変換
        const coord3857 = geometry.getCoordinates();
        const coordLonLat = toLonLat(coord3857);

        // Turfで距離を計算
        return distance(basePointLonLat, coordLonLat);
    });
};
